const defaultShare = {
  title: 'DEKA产品官方验证查询',
  desc: '查询DEKA官方授权机构与设备验证信息。',
  imgUrl: `${window.location.origin}${process.env.BASE_URL || '/'}share-card.png`,
  link: window.location.href.split('#')[0]
}

export async function setupWechatShare(options = {}) {
  if (!isWechat() || !window.wx) return

  const share = {
    ...defaultShare,
    ...options
  }

  try {
    const signature = await getWechatSignature()
    if (!signature) return

    window.wx.config({
      debug: false,
      appId: signature.appId,
      timestamp: signature.timestamp,
      nonceStr: signature.nonceStr,
      signature: signature.signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'onMenuShareAppMessage',
        'onMenuShareTimeline'
      ]
    })

    window.wx.ready(() => {
      window.wx.updateAppMessageShareData(share)
      window.wx.updateTimelineShareData({
        title: share.title,
        link: share.link,
        imgUrl: share.imgUrl
      })

      // Older WeChat clients still use these APIs.
      window.wx.onMenuShareAppMessage(share)
      window.wx.onMenuShareTimeline({
        title: share.title,
        link: share.link,
        imgUrl: share.imgUrl
      })
    })
  } catch (error) {
    // Keep normal page usage intact if the share-signature API is not ready yet.
    void error
  }
}

function isWechat() {
  return /micromessenger/i.test(window.navigator.userAgent)
}

async function getWechatSignature() {
  const api = process.env.VUE_APP_WECHAT_SIGNATURE_API || '/api/wechat/signature'
  const url = encodeURIComponent(window.location.href.split('#')[0])
  const response = await fetch(`${api}?url=${url}`)
  if (!response.ok) return null
  return response.json()
}
